import { createCommand } from '@atlassian/rovo-content-bridge-api';
/**
 * A command sent by the rovo client to send the error message to the inline input box.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to send the error message to the inline input box.
 */
export var InlineInputBoxErrorMessageCommand = createCommand('inline-input-box-error-message-command');